import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> { }

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, ...props }, ref) => {
        return (
            <textarea
                /*
                 * 🔴 `text-base md:text-sm` — **anti-zoom iOS**, pas une
                 * préférence de taille.
                 *
                 * Sous 16 px, Safari iOS ZOOME automatiquement la page au focus
                 * d'un champ, et n'en ressort pas : l'utilisateur se retrouve sur
                 * un écran agrandi qu'il doit repincer à la main, à chaque champ.
                 * `ui/input.tsx` porte la garde depuis toujours et le design
                 * system la grave deux fois (§13.6 « saisie tactile en
                 * `text-base`, jamais `text-sm` » ; §14 « tout champ éditable
                 * porte `text-base md:text-sm` »).
                 *
                 * Ce composant-ci ne l'avait pas — un oubli du socle, pas une
                 * exception : le DS n'en déclare aucune. Tous les `<Textarea>` du
                 * produit zoomaient donc au focus sur iPhone, et une zone de
                 * saisie longue est précisément celle où l'on reste le plus
                 * longtemps.
                 */
                className={cn(
                    "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm ring-offset-background placeholder:text-muted-foreground placeholder:italic placeholder:opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                    className
                )}
                ref={ref}
                {...props}
            />
        )
    }
)
Textarea.displayName = "Textarea"

export { Textarea }
